import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  id: "sidebar",
  class: "w-64 bg-white min-h-screen border-r border-gray-200 fixed left-0 top-13"
}
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "px-6 py-2" }
const _hoisted_4 = { class: "mt-2 divide-y divide-gray-100" }
const _hoisted_5 = { href: "/dashboard" }
const _hoisted_6 = { href: "/apikeys" }
const _hoisted_7 = { href: "/apirequests" }
const _hoisted_8 = { href: "/user-mgt" }
const _hoisted_9 = {
  key: 0,
  class: "mt-6 px-6 py-2"
}
const _hoisted_10 = { class: "mt-2 divide-y divide-gray-100" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "mt-6 px-6 py-2"
}
const _hoisted_13 = { class: "mt-2 divide-y divide-gray-100" }
const _hoisted_14 = { href: "/management/organizations" }
const _hoisted_15 = { href: "/management/services" }
const _hoisted_16 = { href: "/management/topup-requests" }
const _hoisted_17 = { class: "mt-6 px-6 py-2" }
const _hoisted_18 = { class: "mt-2 divide-y divide-gray-100" }
const _hoisted_19 = {
  key: 0,
  href: "/billing/ledger"
}

import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import { useServicesStore } from '@/store/services';


export default /*@__PURE__*/_defineComponent({
  __name: 'sidebar',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const servicesStore = useServicesStore();

const isPublicPurpose = computed(() => localStorage.getItem('purpose') === 'public');

const hasManagementPermissions = computed(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose !== 'local') return false;
  const permissions = localStorage.getItem('permissions');
  if (!permissions) return false;
  const permissionList = permissions.split(',').map((p) => p.trim().toLowerCase());
  const managementPermissions = [
    'manage_organizations',
    'manage_accounts',
    'create_topup_requests',
    'approve_topup_requests',
    'view_topup_requests',
  ];
  return permissionList.some((permission) => managementPermissions.includes(permission));
});

const ALL_VERIFICATION_ITEMS = [
  { serviceName: 'PhoneValidation', path: '/validations/phone', label: 'Phone Validation', icon: 'fa-phone' },
  { serviceName: 'NINValidation', path: '/validations/id', label: 'NIN Validation', icon: 'fa-id-card' },
  { serviceName: 'NINMatchValidation', path: '/validations/id-match', label: 'NIN Match Validation', icon: 'fa-id-card' },
  { serviceName: 'KYCValidation', path: '/validations/kyc', label: 'KYC Validation', icon: 'fa-building' },
];

const visibleVerificationItems = computed(() => {
  if (!isPublicPurpose.value) {
    return ALL_VERIFICATION_ITEMS;
  }
  if (!servicesStore.subscriptions?.length) return [];
  const subscribedNames = new Set(
    servicesStore.subscriptions.map((s) => s.serviceName ?? ''),
  );
  return ALL_VERIFICATION_ITEMS.filter((item) => subscribedNames.has(item.serviceName));
});

onMounted(() => {
  if (isPublicPurpose.value) {
    const user = authStore.user as any;
    const organizationId = user?.organizationId;
    if (organizationId && !servicesStore.subscriptions.length) {
      servicesStore.fetchSubscriptions(organizationId);
    }
  }
});

function isActive(path: string) {
  return route.path === path;
}

async function handleLogout() {
  authStore.logout();
  await router.push('/login');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xs font-semibold text-gray-500 tracking-wider uppercase" }, "MAIN", -1)),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["block px-3 py-2 text-sm font-medium rounded-md flex items-center cursor-pointer", isActive('/dashboard') ? 'text-green-600 bg-green-50' :
                'text-gray-700'])
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fa-solid fa-chart-line mr-3" }, null, -1),
              _createTextVNode(" Dashboard ", -1)
            ]), 2)
          ]),
          _createElementVNode("a", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/apikeys') ? 'text-green-600 bg-green-50' :
              'text-gray-700'])
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "fa-solid fa-key mr-3" }, null, -1),
              _createTextVNode(" API Keys ", -1)
            ]), 2)
          ]),
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/apirequests') ? 'text-green-600 bg-green-50' :
                'text-gray-700'])
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fa-solid fa-list mr-3" }, null, -1),
              _createTextVNode(" API Requests ", -1)
            ]), 2)
          ]),
          _createElementVNode("a", _hoisted_8, [
            _createElementVNode("span", {
              class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/user-mgt') ? 'text-green-600 bg-green-50' :
                'text-gray-700'])
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fa-solid fa-users mr-3" }, null, -1),
              _createTextVNode(" User Management ", -1)
            ]), 2)
          ])
        ])
      ]),
      (visibleVerificationItems.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-xs font-semibold text-gray-500 tracking-wider uppercase" }, "VERIFICATION", -1)),
            _createElementVNode("nav", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleVerificationItems.value, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: item.path,
                  href: item.path
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive(item.path) ? 'text-green-600 bg-green-50' : 'text-gray-700'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`fa-solid ${item.icon} mr-3`)
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(item.label), 1)
                  ], 2)
                ], 8, _hoisted_11))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (hasManagementPermissions.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-xs font-semibold text-gray-500 tracking-wider uppercase" }, "MANAGEMENT", -1)),
            _createElementVNode("nav", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, [
                _createElementVNode("span", {
                  class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/management/organizations') ? 'text-green-600 bg-green-50' : 'text-gray-700'])
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "fa-solid fa-building mr-3" }, null, -1),
                  _createTextVNode(" Organizations ", -1)
                ]), 2)
              ]),
              _createElementVNode("a", _hoisted_15, [
                _createElementVNode("span", {
                  class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/management/services') ? 'text-green-600 bg-green-50' : 'text-gray-700'])
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fa-solid fa-cubes mr-3" }, null, -1),
                  _createTextVNode(" Services ", -1)
                ]), 2)
              ]),
              _createElementVNode("a", _hoisted_16, [
                _createElementVNode("span", {
                  class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/management/topup-requests') ? 'text-green-600 bg-green-50' : 'text-gray-700'])
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fa-solid fa-coins mr-3" }, null, -1),
                  _createTextVNode(" Top-up Requests ", -1)
                ]), 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-xs font-semibold text-gray-500 tracking-wider uppercase" }, "SETTINGS", -1)),
        _createElementVNode("nav", _hoisted_18, [
          (isPublicPurpose.value)
            ? (_openBlock(), _createElementBlock("a", _hoisted_19, [
                _createElementVNode("span", {
                  class: _normalizeClass(["block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer", isActive('/billing/ledger') ? 'text-green-600 bg-green-50' : 'text-gray-700'])
                }, _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fa-solid fa-credit-card mr-3" }, null, -1),
                  _createTextVNode(" Billing ", -1)
                ]), 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            onClick: handleLogout,
            onKeyup: _withKeys(handleLogout, ["enter"]),
            tabindex: "0",
            role: "button"
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("span", { class: "block px-3 py-2 text-sm font-medium text-gray-700 rounded-md flex items-center hover:bg-gray-50 cursor-pointer" }, [
              _createElementVNode("i", { class: "fa-solid fa-user-circle mr-3" }),
              _createTextVNode(" Log Out ")
            ], -1)
          ]), 32)
        ])
      ])
    ])
  ]))
}
}

})